import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { AlertButtonProps, useAlert } from '@rahtab/ui';
import { NavigationProp, useNavigation } from '@react-navigation/core';
import useCheckWorkflow from 'hooks/useCheckWorkflow';
import { useEffect } from 'react';
import { useAppDispatch } from 'rahtab-redux';
import { loadsLoading } from 'rahtab-redux/slices/loadsSlice';
import { setCorrectionsLoading } from 'rahtab-redux/slices/correctionListSlice';
import { RootStackType } from '../../Router';

function useSubmitRevision({
  assignFinalCode,
  remainingAmount,
  reasonCode,
  comment,
  compileDC,
  wfInstanceCode,
  autoReStock,
  stateCode,
}: SubmitRevisionProps) {
  const formData = new FormData();
  formData.append(
    'CorrectionInfo',
    JSON.stringify({
      AssignFinallCode: assignFinalCode,
      ReasonCode: reasonCode,
      RealRemaining: remainingAmount,
      Comment: comment,
      CompileDC: compileDC,
      WfInstanceCode: wfInstanceCode,
      AutoReStock: autoReStock,
    }),
  );
  const alert = useAlert();
  const dispatch = useAppDispatch();
  const { goBack } = useNavigation<NavigationProp<RootStackType>>();
  const [submitRevision, result] = useFetchCallType<ServerCorrectionResult>('SaveCorrectionRemaining', {
    data: formData,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    skip: true,
  });

  const { checkWorkflow, loading: wfLoading, data: wfResult, called: wfCalled } = useCheckWorkflow({
    wfInstanceCode,
    stateCode,
  });
  const buttons: AlertButtonProps[] = [
    {
      color: 'secondary',
      variant: 'outlined',
      text: 'بازگشت',
      onPress: () => {
        dispatch(loadsLoading('refreshing'));
        dispatch(setCorrectionsLoading('refreshing'));
        goBack();
      },
    },
  ];
  useEffect(() => {
    if (wfCalled && !wfLoading) {
      if (wfResult?.finished) {
        if (result.data) {
          const { error, message, result: success } = result.data;
          alert({
            notClosableByOutsidePress: true,
            title: 'پیام سیستم',
            message: success ? message : error,
            severity: success ? 'success' : 'error',
            hideBackButton: success,
            buttons,
          });
        }
      } else {
        alert({
          notClosableByOutsidePress: true,
          title: 'پیام سیستم',
          message: 'درخواست شما در سیستم ثبت شد و در حال پردازش می‌باشد.',
          severity: 'success',
          hideBackButton: true,
          buttons,
        });
      }
      // dispatch(loadsLoading('refreshing'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wfLoading]);

  useEffect(() => {
    if (!result.loading && result.data) {
      const { error, result: success } = result.data;
      if (success) {
        checkWorkflow();
      } else {
        alert({
          title: 'پیام سیستم',
          message: error,
          severity: 'error',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.loading]);
  return { submitRevision, loading: result.loading || wfLoading };
}
export default useSubmitRevision;

interface SubmitRevisionProps {
  assignFinalCode: string;
  remainingAmount: string;
  reasonCode: string;
  comment: string;
  compileDC: string;
  wfInstanceCode: string;
  stateCode: string;
  autoReStock: '0' | '1';
}

interface ServerCorrectionResult {
  error: string;
  message: string;
  result: boolean;
}
